module.exports = __webpack_public_path__ + "img/shoot_00023.3841c4cc.png";